import { Alert, Box, Button, TextField } from '@mui/material'
import { getAuthInstance } from '@zealth/core/firebase/runtime'
import { signInWithEmailAndPassword } from 'firebase/auth'
import { type FormEvent, useState } from 'react'

const devDefault = (value: string | undefined): string =>
  import.meta.env.DEV ? (value ?? '') : ''

const AdminSignInForm = () => {
  const [email, setEmail] = useState(
    devDefault(import.meta.env.VITE_PLAYGROUND_AUTH_EMAIL)
  )
  const [password, setPassword] = useState(
    devDefault(import.meta.env.VITE_PLAYGROUND_AUTH_PASSWORD)
  )
  const [error, setError] = useState('')

  const handleSubmit = async (event: FormEvent): Promise<void> => {
    event.preventDefault()
    setError('')

    try {
      await signInWithEmailAndPassword(getAuthInstance(), email, password)
    } catch (caught: unknown) {
      setError(caught instanceof Error ? caught.message : 'Failed to sign in')
    }
  }

  return (
    <Box component="form" onSubmit={handleSubmit}>
      <TextField
        label="Email"
        type="email"
        value={email}
        onChange={event => setEmail(event.target.value)}
        fullWidth
        required
        sx={{ mb: 2 }}
      />
      <TextField
        label="Password"
        type="password"
        value={password}
        onChange={event => setPassword(event.target.value)}
        fullWidth
        required
        sx={{ mb: 2 }}
      />
      <Button type="submit" variant="contained" fullWidth>
        Sign in
      </Button>

      {error && (
        <Alert severity="error" sx={{ mt: 2 }}>
          {error}
        </Alert>
      )}
    </Box>
  )
}

export default AdminSignInForm
